import React, { useEffect, useMemo, useState } from "react";
import {
    Autocomplete,
    Box,
    Button,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    MenuItem,
    Paper,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { GlobalState } from "context/GlobalContext";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";
import { AuthState } from "context/AuthContext";
import { roleAccess } from "../DiscountMasterList";
import { Discount_Master_Brands, DISOUNT_MASTER_CHANNEL_OPTIONS } from "../data";
import FileSaver from "file-saver";

const initialFormData = {
    channel: "",
};

function DiscountStoreMaster() {
    const [formData, setFormData] = useState(initialFormData);
    const [storeRows, setStoreRows] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [file, setFile] = useState("");
    const [editingRowId, setEditingRowId] = useState(null);
    const [editContactNumber, setEditContactNumber] = useState("");
    const [editStoreEmail, setEditStoreEmail] = useState("");
    const [editEmailError, setEditEmailError] = useState("");

    const { user } = AuthState();
    const roleData = roleAccess(user);
    console.log("Sxnaksdjbjkasvbc", roleData)
    const role = ["VIEWER", "EDITOR"].includes(roleData.roles);
    const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();

    const channelOptions = useMemo(
        () =>
            DISOUNT_MASTER_CHANNEL_OPTIONS.filter((item) =>
                roleData?.channelList?.includes(item.key)
            ),
        [roleData]
    );

    const filteredRows = useMemo(() => {
        const query = searchTerm.trim().toLowerCase();
        if (!query) return storeRows;

        return storeRows.filter((row) => {
            const valuesToSearch = [
                row?.store_name,
                row?.store_grade,
            ];

            return valuesToSearch.some((value) =>
                String(value || "").toLowerCase().includes(query)
            );
        });
    }, [storeRows, searchTerm]);

    const getContactValue = (row) =>
        row?.contact_no ||
        "";

    const getEmailValue = (row) => row?.email || "";

    const handleEditStart = (row) => {
        setEditingRowId(row?._rowId);
        setEditContactNumber(getContactValue(row));
        setEditStoreEmail(getEmailValue(row));
        setEditEmailError("");
    };

    const handleEditCancel = () => {
        setEditingRowId(null);
        setEditContactNumber("");
        setEditStoreEmail("");
        setEditEmailError("");
    };

    const handleContactNumberChange = (e) => {
        const digitsOnly = e.target.value.replace(/\D/g, "");
        setEditContactNumber(digitsOnly);
    };

    const isValidEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

    const handleStoreEmailChange = (e) => {
        const value = e.target.value.trim();
        setEditStoreEmail(value);
        if (!value || !isValidEmail(value)) {
            setEditEmailError("Enter a valid email");
            return;
        }
        setEditEmailError("");
    };

    const handleStoreDetailsUpdate = async (updatedRow) => {
        try {

            console.log("sajcbkasbckabskjcb", updatedRow)

            let payload = {
                store_name: updatedRow?.store_name,
                channel: updatedRow?.channel.trim(),
                email: user.email,
                contact_number: editContactNumber,
                store_email: editStoreEmail,
            }

            console.log("ascuiabskfbakscbkabsc", payload)
            // setDownloading(true);
            setLoadingOpen(true);
            await pythonVmInstance({
                url: `/discount-master/update-store-master`,data: payload,
                method: "PUT",
            })
            handleGetStoreData();
            setLoadingOpen(false);
        } catch (error) {
            setSnackBarOpen(true);
            setLoadingOpen(false);
            setSnackBar({
                ...snackBar,
                message: "Failed to download file",
                severity: "error",
                anchorOrigin: { horizontal: "center", vertical: "top" },
            });
        }
    }

    const handleEditSave = () => {
        const trimmedEmail = editStoreEmail.trim();
        if (!trimmedEmail || !isValidEmail(trimmedEmail)) {
            setEditEmailError("Enter a valid email");
            return;
        }
        setStoreRows((prev) =>
            prev.map((item) =>
                item?._rowId === editingRowId
                    ? {
                        ...item,
                        contact_number: editContactNumber,
                        store_email: trimmedEmail,
                    }
                    : item
            )
        );
        handleStoreDetailsUpdate(storeRows.find((item) => item?._rowId === editingRowId));
        handleEditCancel();
    };
    

    const handleFileChange = (e) => {
        const newFile = e.target.files[0];
        if (!newFile) return;

        const modifiedFile = new File([newFile], newFile.name, {
            type: newFile.type,
        });

        setFile(modifiedFile);
    };

    const handleChange = (field) => (e) => {
        setFormData((prev) => ({
            ...prev,
            [field]: e.target.value,
        }));
    };

    const handleDownloadSample = async () => {
        try {
            // setDownloading(true);
            setLoadingOpen(true);
            await pythonVmInstance({
                url: `/discount-master/download-store-master?channel=${formData?.channel}`,
                headers: {
                    "Content-Type": "application/json",
                },
                method: "GET",
                responseType: "blob",
            }).then((res) => {
                const url = URL.createObjectURL(res.data);
                FileSaver.saveAs(url, `${formData?.channel}_store_master_sample.csv`);
                setLoadingOpen(false);
            });
        } catch (error) {
            setSnackBarOpen(true);
            setLoadingOpen(false);
            setSnackBar({
                ...snackBar,
                message: "Failed to download file",
                severity: "error",
                anchorOrigin: { horizontal: "center", vertical: "top" },
            });
        }
    };

    const handleFileUpload = async (e) => {
        e.preventDefault();
        setLoadingOpen(true);
        let form = new FormData();
        if (file === "") {
            // setLoadingOpen(false);
            setSnackBarOpen(true);
            setSnackBar({
                ...snackBar,
                message: "Please upload some files and try again",
                severity: "warning",
                anchorOrigin: { horizontal: "center", vertical: "top" },
            });
            setLoadingOpen(false);
            return;
        }

        form.append("files", file);
        form.append("email", user.email);
        form.append("channel", formData?.channel);
        pythonVmInstance
            .post("/discount-master/upload-store-master", form, { headers: { "Content-Type": "multipart/form-data" } })
            .then((res) => {
                setLoadingOpen(false);
                setSnackBarOpen(true);
                setSnackBar({
                    ...snackBar,
                    message: "Uploaded the files successfully",
                    severity: "success",
                    anchorOrigin: { horizontal: "center", vertical: "top" },
                });
                console.log("sldjlisjdfhasdf", res?.data)
                document.getElementById("fileInput").value = "";
                setFile("")
                handleGetStoreData()
            })
            .catch((err) => {
                console.log("uploaded", err);
                const message = err?.response?.data?.message;
                setLoadingOpen(false);
                setSnackBarOpen(true);
                setSnackBar({
                    ...snackBar,
                    message: message ? message : "Unable to uploaded the files",
                    severity: "error",
                    anchorOrigin: { horizontal: "center", vertical: "top" },
                });
            });
    };

    const handleGetStoreData = async () => {
        try {
            if (!formData?.channel) {
                 setSnackBarOpen(true);
                setSnackBar({
                    ...snackBar,
                    message:"Please sect the channel and try again",
                    severity: "error",
                    anchorOrigin: { horizontal: "center", vertical: "top" },
                });
                return;
            }
            setLoadingOpen(true);
            pythonVmInstance
                        .get(`/discount-master/discount-store-master?channel=${formData?.channel}`)
            .then((res) => {
                 const normalizedRows = (res?.data || []).map((item, index) => ({
                    ...item,
                    _rowId:
                        item?.store_code ||
                        item?.storeCode ||
                        item?.id ||
                        `row-${index}`,
                 }));
                 setStoreRows(normalizedRows);
                 setLoadingOpen(false);
            })
        } catch (err) {
            const message = err?.response?.data?.message;
            setSnackBarOpen(true);
            setSnackBar({
                ...snackBar,
                message: message || "Unable to fetch approval master data",
                severity: "error",
                anchorOrigin: { horizontal: "center", vertical: "top" },
            });
            setLoadingOpen(false);
        }
    };

    useEffect(() => {
        if (formData?.channel){
            handleGetStoreData();
        }
    }, [formData?.channel]);


    console.log("dsfghjopkhgf", storeRows)

    return (
        <Stack width="98%" p={2} maxHeight={500} spacing={2}>
            <Box display="flex" columnGap={2} mb="16px">
                <Box display="flex" columnGap={2} mb="16px">
                    <TextField
                        select
                        label="Channel"
                        size="small"
                        sx={{ minWidth: 130 }}
                        value={formData.channel}
                        onChange={handleChange("channel")}
                    >
                        {channelOptions.map((item) => (
                            <MenuItem key={item.key} value={item.key}>
                                {item.name}
                            </MenuItem>
                        ))}
                    </TextField>
                </Box>
                <Box display="flex" justifyContent="flex-end" alignItems="center" flex={1}>
                    <Button variant="contained" onClick={handleGetStoreData}>
                        Get Stores
                    </Button>
                </Box>
            </Box>
            <Box display="flex" columnGap={2} mb="16px">
                <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                    width="30%"
                    sx={{ border: "1px solid lightgray" }}
                    padding="5px"
                    borderRadius="4px"
                >
                    <Button
                        variant="outlined"
                        size="small"
                        component="label"
                        sx={{ height: 28, fontSize: "12px", textTransform: "none" }}
                        disabled={role}
                    >
                        Choose File
                        <input
                            type="file"
                            hidden
                            id = "fileInput"
                            accept=".csv,text/csv"
                            onChange={handleFileChange}
                            disabled={role}
                        />
                    </Button>

                    <Typography variant="caption" width="200px" noWrap>
                        {file?.name || "No file chosen"}
                    </Typography>
                </Box>
                <Button variant="contained" disabled={role} onClick={handleFileUpload}>
                    Upload
                </Button>
                <Button variant="contained" disabled={role} onClick={handleDownloadSample}>
                    Download
                </Button>
            </Box>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                <Typography fontWeight={600}>
                    Store Details
                </Typography>
                <TextField
                    size="small"
                    label="Search"
                    placeholder="Store name, grade..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    sx={{ minWidth: 320 }}
                />
            </Box>
            <TableContainer component={Paper} sx={{ maxHeight: 320 }}>
                <Table size="small" sx={{ minWidth: 700 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ minWidth: 50 }}>S.No</TableCell>
                            <TableCell sx={{ minWidth: 200 }}>Store Name</TableCell>
                            <TableCell sx={{ minWidth: 100 }}>Channel</TableCell>
                            <TableCell sx={{ minWidth: 140 }}>Brand</TableCell>
                            <TableCell sx={{ minWidth: 100 }}>Store Grade</TableCell>
                            <TableCell sx={{ minWidth: 100 }}>Zone</TableCell>
                            <TableCell sx={{ minWidth: 140 }}>State</TableCell>
                            <TableCell sx={{ minWidth: 140 }}>City</TableCell>
                            <TableCell sx={{ minWidth: 170 }}>Contact Number</TableCell>
                            <TableCell sx={{ minWidth: 220 }}>Store Email</TableCell>
                            <TableCell sx={{ minWidth: 150 }}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredRows?.length ? (
                            filteredRows.map((row, index) => (
                                <TableRow key={row?._rowId || index}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{row?.store_name || row?.storeName || "-"}</TableCell>
                                    <TableCell>{row?.channel || row?.channel_name || "-"}</TableCell>
                                    <TableCell>{row?.brand || row?.brand_name || "-"}</TableCell>
                                    <TableCell>{row?.store_grade || "-"}</TableCell>
                                    <TableCell>{row?.zone || "-"}</TableCell>
                                    <TableCell>{row?.state || row?.state_name || "-"}</TableCell>
                                    <TableCell>{row?.city || row?.city_name || "-"}</TableCell>
                                    <TableCell>
                                        {editingRowId === row?._rowId ? (
                                            <TextField
                                                size="small"
                                                value={editContactNumber}
                                                onChange={handleContactNumberChange}
                                                placeholder="Contact Number"
                                                inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                                            />
                                        ) : (
                                            getContactValue(row) || "-"
                                        )}
                                    </TableCell>
                                    <TableCell>
                                        {editingRowId === row?._rowId ? (
                                            <TextField
                                                size="small"
                                                value={editStoreEmail}
                                                onChange={handleStoreEmailChange}
                                                placeholder="Store Email"
                                                error={Boolean(editEmailError)}
                                                helperText={editEmailError}
                                            />
                                        ) : (
                                            getEmailValue(row) || "-"
                                        )}
                                    </TableCell>
                                    <TableCell>
                                        {editingRowId === row?._rowId ? (
                                            <Stack direction="row" spacing={1}>
                                                <Button size="small" variant="contained" onClick={handleEditSave} disabled={role}>
                                                    Save
                                                </Button>
                                                <Button size="small" variant="outlined" onClick={handleEditCancel}>
                                                    Cancel
                                                </Button>
                                            </Stack>
                                        ) : (
                                            <IconButton size="small" onClick={() => handleEditStart(row)} disabled={role}>
                                                <EditIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={11} align="center">
                                    {storeRows?.length ? "No matching stores found" : "No store details found"}
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

        </Stack>
    );
}

export default DiscountStoreMaster;
